import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, Observable } from 'rxjs';
import { OktaService } from 'src/app/services/okta.service';
import { environment } from 'src/environments/environment';
import { switchMap } from 'rxjs/operators';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: OktaService) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Convert the promise-based token getter to Observable
    return from(this.authService.getAccessToken()).pipe(
      switchMap(token => {
        
        let modifiedReq = req;
        let coraiAccesstoken:any = localStorage.getItem('corai_token') || '';
        // Check if URL requires no auth header
        let coreUrl = this.noAuthHeaderRequired(req.url);
        if (token) {
          const tokenStorage = localStorage.getItem('okta-token-storage');
          const tokenObj = tokenStorage ? JSON.parse(tokenStorage) : null;
          const accessToken = tokenObj?.accessToken?.accessToken;
          
          if(req.url.includes(environment.podurl)){
            modifiedReq = req.clone({
              headers: req.headers
                .set('Authorization', this.isBearerRequired(req.url) ? `Bearer ${accessToken}` : accessToken)
              // .set('old-ui', 'prod')
              // .set('new-ui', 'prod')
            });
          } else {
            modifiedReq = req.clone({
              headers: req.headers
                .set('Authorization', this.isBearerRequired(req.url) ? `Bearer ${token}` : token)
                .set('Auth-Platform', 'mobile')
                .set('old-ui', 'prod')
                .set('corai-auth', coreUrl?.status ? coraiAccesstoken : '')
            });
          }
          
        }

        return next.handle(modifiedReq);
      })
    );
  }




  private isBearerRequired(url: string): boolean {
    // add bearer before specific token  starts
    let bearerEndpoints = ['translate_upload', 'translate_start', 'translate_status',
      'chat_history', 'delete_p', 'old_chat', 'chat_update', 'new_chat','edit_title',
      'upload_video', 'status', 'transcript', 'uploading', 'submitting', 'image-generate',
      'upload-jd', 'upload-cv', 'calculate-match-jd', 'calculate-match-cv', 'submit-match',
      'recent_bing', 'recent_response', 'sentiments-analysis', 'recent_collection', 'translate_upload_glossary',
      'translate_upload_image', 'init', 'upload', 'list', 'manage', 'export', 'process', 'translate-text',
      'get-dictionary', 'azure_csv_resp', 'analyze_sentiment', 'image-modify', 'byod-status', 'getanswer', 'uploader',
      'translate', 'download', 'store_logs', 'translate_upload_image', 'translate_download_file', 'translate_delete_files',
      'queryVS-status', 'store_logs', 'subsidy-policy-search', 'subsidy-policy-status', 'subsidy-policy-crawl', 'azure-dalle3',
      'chat-bot-stream', 'chat-bot-stream-new', 'create-assistant',
      'search-bing-images', 'chat-bot-clear', 'chat-uploads-status', 'chat-uploads', 'podcasts', 'generate-conversation', 'conversion-status', 'generate-audio',
      'audio',
      'run-status', 'first-query', 'add-query', 'da-plugin','graphapi','chat','upload','gen-prompt',
      'translate-text-aon'
    ];

    // Get the API URL endpoint
    let apiEndpoint = url.split('/');
    var finalUrl = apiEndpoint[apiEndpoint?.length - 1].split('?')[0];
    const podcastPattern = /\/podcasts\/[a-zA-Z0-9]+$/;
    return bearerEndpoints.includes(finalUrl) || podcastPattern.test(url);
  }

  private noAuthHeaderRequired(url: string) {
    // add bearer before specific token  starts
    let bearerEndpoints = ['user-detail', 'bot-history','bot-work-history', 'create-prompt','prompt-filter'];

    // Get the API URL endpoint
    let apiEndpoint = url.split('/');
    var finalUrl = apiEndpoint[apiEndpoint?.length - 1].split('?')[0];
    let result: any = { url: finalUrl, status: bearerEndpoints.includes(finalUrl) }
    return result;
  }
}
